export const typography_deco = [
  { char: '〰️', name: 'Wavy Dash', nameZh: '波浪線', keywords: ['line', 'split', 'deco'], hot: true },
  { char: '➖', name: 'Minus Sign', nameZh: '長橫線', keywords: ['line', 'split'] },
  { char: '▪️', name: 'Small Black Square', nameZh: '黑色方點', keywords: ['bullet', 'list'] },
  { char: '▫️', name: 'Small White Square', nameZh: '白色方點', keywords: ['bullet', 'list'] },
  { char: '◾', name: 'Medium Black Square', nameZh: '中黑方點', keywords: ['bullet', 'point'] },
  { char: '◽', name: 'Medium White Square', nameZh: '中白方點', keywords: ['bullet', 'point'] },
  { char: '◼️', name: 'Large Black Square', nameZh: '大黑方塊', keywords: ['block', 'shape'] },
  { char: '◻️', name: 'Large White Square', nameZh: '大白方塊', keywords: ['block', 'shape'] },
  { char: '⬛', name: 'Black Large Square', nameZh: '全黑塊', keywords: ['color', 'black'] },
  { char: '⬜', name: 'White Large Square', nameZh: '全白塊', keywords: ['color', 'white'] },
  { char: '🔶', name: 'Large Orange Diamond', nameZh: '大橘菱形', keywords: ['shape', 'point'] },
  { char: '🔷', name: 'Large Blue Diamond', nameZh: '大藍菱形', keywords: ['shape', 'point'], hot: true },
  { char: '🔸', name: 'Small Orange Diamond', nameZh: '小橘菱形', keywords: ['shape', 'point'] },
  { char: '🔹', name: 'Small Blue Diamond', nameZh: '小藍菱形', keywords: ['shape', 'point'], hot: true },
  { char: '💠', name: 'Diamond with Dot', nameZh: '花瓣菱形', keywords: ['deco', 'flower', 'blue'] },
];